import { Link } from "react-router-dom";
import React from "react";
import { withRouter } from "react-router-dom";
import Table from "grommet/components/Table";
import TableRow from "grommet/components/TableRow";
import Box from "grommet/components/Box";
import StatBox from "../../components/StatBox";
import Loader from "../../components/LoaderOverlay";
import styled from "styled-components";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

const Container = styled.div`
  padding: 12px;
`;

const StatContainer = styled(Box)`
  margin-top: 8px;
  border-radius: 10px;
`;

const CustomersContainer = styled(Box)`
  padding: 35px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(218, 218, 218, 0.5);
`;

const CustomersTable = styled(Table)`
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #696969;

  th {
    font-weight: 700;
    text-transform: uppercase;
  }
`;

const CustomerList = props => {
  console.log("props are -> ", props);

  if (props.data.loading) {
    return <Loader />;
  } else {
    const tableRows = props.data.account.account_apps[0].app_customers.edges.map(
      customer => (
        <TableRow
          onClick={() => {
            props.history.push("/app/customer/" + customer.node.id);
          }}
        >
          <td>{customer.node.id}</td>
          <td>{customer.node.email}</td>
          <td className="secondary">{customer.node.usage_health_score}</td>
          <td className="secondary">{customer.node.monthly_amount}</td>
        </TableRow>
      )
    );

    console.log(tableRows);

    return (
      <Container>
        <StatContainer direction="row" justify="start" falign="center">
          <StatBox
            active
            mr
            color={"#7FCEFF"}
            stat={"165"}
            title={"All Customers"}
          />
          <StatBox mr color={"#45EAAF"} stat={"2,040"} title={"Good Health"} />
          <StatBox
            mr
            color={"#FAE17E"}
            stat={"3,900"}
            title={"Moderate Health"}
          />
          <StatBox color={"#FE876E"} stat={"3,400"} title={"Poor Health"} />
        </StatContainer>
        <CustomersContainer direction="row" justify="start" align="center">
          <CustomersTable selectable={true}>
            <thead>
              <tr>
                <th>Id</th>
                <th>Email</th>
                <th>Usage Health Score</th>
                <th>Monthly Amount</th>
              </tr>
            </thead>
            <tbody>{tableRows}</tbody>
          </CustomersTable>
        </CustomersContainer>
      </Container>
    );
  }
};

const CUSTOMER_LIST_QUERY = gql`
  query account($lastId: String) {
    account {
      account_apps {
        id
        app_customers(first: 10, after: $lastId) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              email
              usage_health_score
              monthly_amount
            }
          }
        }
      }
    }
  }
`;

const CustomerListWithData = graphql(CUSTOMER_LIST_QUERY, {
  variables: {
    lastId: "Mw=="
  }
})(CustomerList);

export default withRouter(CustomerListWithData);



// WEBPACK FOOTER //
// ./src/containers/loggedIn/customers.js